define("ember-changeset-validations/utils/messages", ["exports", "ember-validators/messages", "@ember/string"], function (_exports, _messages, _string) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-validators/messages",0,"@ember/string"eaimeta@70e063a35619d71f
  const Messages = Object.assign({}, _messages.default);
  var _default = _exports.default = Object.assign(Messages, {
    // Blank and present are flipped in ember-validators. Need to flip them back here
    blank: _messages.default.present,
    present: _messages.default.blank,
    getDescriptionFor() {
      let key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (0, _string.capitalize)((0, _string.dasherize)(key).split(/[._-]/g).join(' '));
    }
  });
});